<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-6 px-8">
        <div>
          <div class="page text-white">
            {{ getLearnerLesson.title }}
          </div>
          <p class="text-white">{{ getLearnerLesson.description }}</p>
        </div>
        <div></div>
      </div>
    </lcontainer>

    <lCrumbs :breadcrumb="breadcrumbItems" />

    <lcontainer>
      <div class="flex justify-center">
        <div class="w-full md:w-3/5">
          <div v-if="getLearnerLesson.lesson_type == 'video'" class="w-full   ">
            <Media
              kind="video"
              :controls="true"
              :src="getLearnerLesson.lesson_resource"
              :style="{ width: '100%' }"
            >
            </Media>
          </div>
          <div v-if="getLearnerLesson.lesson_type == 'article'" class="w-3/4">
            <div v-html="getLearnerLesson.article[0].article"></div>
          </div>
          <div v-if="getLearnerLesson.lesson_type == 'quiz'" class="w-3/4">
            <learner-quiz :quiz="getLearnerLesson.quizzes[0]" />
          </div>
          <div v-if="getLearnerLesson.lesson_type == 'exercise'" class="w-3/4">
            <learner-exercise :exercise="getLearnerLesson.exercises[0]" />
          </div>
          <div v-if="getLearnerLesson.lesson_type == 'survey'" class="w-3/4">
            <learner-survey :survey="getLearnerLesson.survey" />
          </div>

          <div
            v-if="getLearnerLesson.lesson_type == 'growth_plan'"
            class="w-3/4"
          >
            <learner-growth-plan
              :growth_plan="getLearnerLesson.growth_plans[0]"
            />
          </div>
        </div>
        <div class="w-full md:w-2/5">
          <div
            class=" px-2 py-4 rounded overflow-hidden shadow-lg mx-4 my-height overflow-y-scroll"
          >
            <p class="single-course-title main-tenant-color">Course Lessons</p>
            <laccordion class="w-full" />
          </div>
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Media from "@dongido/vue-viaudio";
import { store } from "@/store/store";
export default {
  components: {
    LessonCard: () => import("@/components/learner/lesson-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    LearnerQuiz: () => import("@/views/learner/quiz/quiz"),
    LearnerExercise: () => import("@/views/learner/quiz/exercise"),
    LearnerGrowthPlan: () => import("@/views/learner/quiz/growth_plan"),
    LearnerSurvey: () => import("@/views/learner/quiz/survey"),
    laccordion: () => import("@/components/learner/accordion/container"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    Media,
  },
  data() {
    return {
      breadcrumbItems: [
        {
          disabled: true,
          to: "/learner/my-courses",
          text: "Courses",
        },
        {
          disabled: true,
          to: `/learner/courses/${store.state.learner.learner_course.id}`,
          text: `${store.state.learner.learner_course.title}`,
        },
      ],
      form: {},
      error: {},
      search: "",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchLearnerLesson", "fetchSingleLearnerCourse"]),
  },
  computed: {
    ...mapGetters(["getLearnerLesson", "getLearnerCourse"]),
  },
  async created() {
    await this.fetchLearnerLesson({ id: this.$route.params.lesson });
    await this.fetchSingleLearnerCourse({
      id: this.getLearnerLesson.course_id,
    });
    //console.log({ dddd: this.getLearnerLesson });
  },
};
</script>
<style lang="scss" scoped>
.navs {
  color: color(lms-tenant);
}

.my-height {
  height: 36rem;
}
</style>
